/** @jsxImportSource @emotion/react */

import {
  CSSRulesResolver,
  useCSSRulesWithTheme,
} from "hooks/useCSSRulesWithTheme";
import { FC, ReactNode } from "react";

const getCSSRules: CSSRulesResolver<{ hasHover?: boolean }> = ({
  colors,
  hasHover,
}) => ({
  outer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    flexGrow: 1,
  },
  container: {
    width: "100%",
    border: `1px solid ${colors.Grey[300]}`,
    borderRadius: 12,
    cursor: hasHover ? "pointer" : "default",
    transition: "0.3s ease",

    "&:hover": {
      ...(hasHover && {
        cursor: "pointer",
        boxShadow: `0px 4px 8px ${colors.Grey[200]}`,
        borderColor: colors.Hannibal[500],
      }),
    },
  },
  inner: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 16px",
    margin: "16px 0",
    gap: 8,
  },
  icon: {
    display: "flex",
    flexShrink: 0,
    alignItems: "center",
    justifyContent: "center",
  },
});

const Card: FC<{
  children?: ReactNode;
  icon?: ReactNode;
  className?: string;
  iconClassName?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  footer?: ReactNode;
}> = ({ children, icon, className, iconClassName, onClick, footer }) => {
  const styles = useCSSRulesWithTheme(getCSSRules, { hasHover: !!onClick });

  return (
    <div css={styles.outer}>
      <div
        onClick={(e) => onClick?.(e)}
        css={styles.container}
        className={className}
      >
        <div css={styles.inner}>
          {icon && (
            <div css={styles.icon} className={iconClassName}>
              {icon}
            </div>
          )}
          {children}
        </div>
      </div>
      {footer}
    </div>
  );
};

export default Card;
